import { IUntypedQuery, Topics } from '@zaplify/common';
import { ProspectSearchFiltersDto } from '../sources';

export class GetProspectingPreviewExpandOrganizationQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(
        readonly userId: string,
        readonly userOrganizationId: string,
        readonly prospectSearchFilters: ProspectSearchFiltersDto,
        readonly expandCompanyName: string,
        readonly size: number,
        readonly from: number,
    ) {
        super();
    }
}
